// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23cKg","content":"styles_content__3E5Er"};